<template>
  <section>
    <h3>Dokument hinzufügen</h3>
    <div class="o-grid o-grid--wrap o-grid--full@small">
      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input
          id="titleDe"
          ref="titleDe"
          label="Bezeichnung (de)"
          placeholder="Bezeichnung (de)"
          v-model="value.titleDe"
          :error="errors.titleDe"
          required
        />
      </div>
      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input
          id="urlDe"
          ref="urlDe"
          label="Link (de)"
          placeholder="Link (de)"
          v-model="value.linkDe"
        />
      </div>

      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input
          id="titleFr"
          ref="titleFr"
          label="Bezeichnung (fr)"
          placeholder="Bezeichnung (fr)"
          v-model="value.titleFr"
          :error="errors.titleFr"
          required
        />
      </div>
      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input
          id="urlFr"
          ref="urlFr"
          label="Link (fr)"
          placeholder="Link (fr)"
          v-model="value.linkFr"
        />
      </div>

      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input
          id="titleEn"
          ref="titleEn"
          label="Bezeichnung (en)"
          placeholder="Bezeichnung (en)"
          v-model="value.titleEn"
          :error="errors.titleEn"
          required
        />
      </div>
      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input
          id="urlEn"
          ref="urlEn"
          label="Link (en)"
          placeholder="Link (en)"
          v-model="value.linkEn"
        />
      </div>

      <div class="o-grid__cell o-grid__cell--width-50">
        <bos-input label="Verfügbarkeitsdatum" v-model="value.publish" />
      </div>
      <div class="o-grid__cell o-grid__cell--width-100 u-right">
        <bos-button
          @click="clearDoc"
          v-if="
            value.titleDe ||
              value.linkDe ||
              value.titleFr ||
              value.linkFr ||
              value.titleEn ||
              value.linkEn ||
              value.publish
          "
          >abbrechen</bos-button
        >&nbsp;
        <bos-button @click="saveDoc">Dokument speichern</bos-button>
      </div>
    </div>
  </section>
</template>

<script>
import BosInput from './BosInput'
import BosButton from './BosButton'
import FormValidator from '../services/FormValidator'

export default {
  name: 'BosAdminDocumentForm',
  model: {
    prop: 'value',
    event: 'input'
  },
  data() {
    return {
      errors: {
        titleDe: {
          hasError: false
        },
        titleFr: {
          hasError: false
        },
        titleEn: {
          hasError: false
        },
        dateRange: {
          hasError: false
        }
      }
    }
  },
  components: { BosButton, BosInput },
  props: {
    value: {}
  },
  methods: {
    getValidationRules() {
      //rules
      var validationRules = [
        {
          value: this.value.titleDe,
          required: true,
          errorKey: 'titleDe'
        },
        {
          value: this.value.titleFr,
          required: true,
          errorKey: 'titleFr'
        },
        {
          value: this.value.titleEn,
          required: true,
          errorKey: 'titleEn'
        }
      ]
      return validationRules
    },
    saveDoc() {
      const that = this
      FormValidator.validateForm(this.getValidationRules(), this.errors).then(
        () => {
          that.$emit('input', that.value)
        }
      )
    },
    clearDoc() {
      this.$emit('onclear')
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  padding: 1rem;
}
</style>
